let elementName = `nss-buybox-sticky-atc-variant`;
if (typeof customElements.get(elementName) === `undefined`) {

    class NSSBuyboxStickyATC extends HTMLElement {

        constructor() {
            super();

            this.debug = false;
        }

        init() {
        }

        connectedCallback() {
            if (this.debug) console.log(`[NSS][Buybox Sticky ATC] Connected.`);

            this.init();

            this.initStickyObservers();

        }




        initStickyObservers() {
            const controlsEls = document.querySelectorAll(`.product__info-wrapper`);
            const footerEl = document.querySelector(`nss-footer`);
console.log(controlsEls, footerEl)

            const observerOptions = {
                root: null,
                threshold: 0.1,
            };

            // defaults
            this.controlsInView = true;
            this.footerInView = false;

            const observerCallback = (entries) => {
                entries.forEach((entry) => {
                    if (entry.target === footerEl) {
                        this.footerInView = entry.isIntersecting;
                    } else {
                        this.controlsInView = entry.isIntersecting;
                    }

                    if (!this.controlsInView && !this.footerInView) {
                        this.showStickyBar();
                    } else {
                        this.hideStickyBar();
                    }
                });
            };

            const observer = new IntersectionObserver(
                observerCallback,
                observerOptions
            );

            controlsEls.forEach((controlsEl) => {
                observer.observe(controlsEl);
            });
            observer.observe(footerEl);
        }

        showStickyBar() {
            this.classList.add(`nss-open`);
        }

        hideStickyBar() {
            this.classList.remove(`nss-open`);
        }

    }

    customElements.define(elementName, NSSBuyboxStickyATC);
} else {
    console.warn(`[NSS] Element '${elementName}' already defined.`);
}